module.exports = __webpack_public_path__ + "img/non_inventory.9d3e81d2.png";